import { PaletteMode } from '@mui/material';
import * as ACTION_TYPES from '../actions/actionTypes';
import { StoreReducerProps, StoreReducerReturn } from '../actions/actions';

export const initialState = {
  isAuthenticated: false,
  redirectUrl: '',
  email: '',
  firstName: '',
  lastName: '',
  picture: '',
  idToken: '',
  isClient: false,
  clientId: '',
  clientName: '',
  platformId: '',
  platformName: '',
  platformSubdomain: '',
  siteId: '',
  siteSlug: '',
  path: '',
  paletteMode: 'light' as PaletteMode,
};

export const StoreReducer = (
  state: StoreReducerProps,
  action: StoreReducerReturn,
): StoreReducerProps => {
  switch (action.type) {
    case ACTION_TYPES.SET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.redirectUrl || initialState.redirectUrl,
      };
    case ACTION_TYPES.UNSET_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: initialState.redirectUrl,
      };
    case ACTION_TYPES.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        email: action.email || initialState.email,
        firstName: action.firstName || initialState.firstName,
        lastName: action.lastName || initialState.lastName,
        picture: action.picture || initialState.picture,
        idToken: action.idToken || initialState.idToken,
      };
    case ACTION_TYPES.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        email: initialState.email,
        firstName: initialState.firstName,
        lastName: initialState.lastName,
        picture: initialState.picture,
        idToken: initialState.idToken,
      };
    case ACTION_TYPES.SELECT_SITE:
      return {
        ...state,
        isClient: !!action.siteId,
        clientId: action.clientId || initialState.clientId,
        clientName: action.clientName || initialState.clientName,
        platformId: action.platformId || initialState.platformId,
        platformName: action.platformName || initialState.platformName,
        platformSubdomain: action.platformSubdomain || initialState.platformSubdomain,
        siteId: action.siteId || initialState.siteId,
        siteSlug: action.siteSlug || initialState.siteSlug,
      };
    case ACTION_TYPES.CHANGE_MODE:
      return {
        ...state,
        paletteMode: action.paletteMode || initialState.paletteMode,
      };
    default:
      return state;
  }
};
